import React from 'react';
import { useTheme } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { applyCustomStyles } from '../Box/utils';

interface IconButtonProps {
  icon: React.ReactNode;
  onClick: () => void;
  ariaLabel: string;
  style?: React.CSSProperties | ((theme: any) => React.CSSProperties);
}

const StyledIconButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== '$customStyles',
})<{ $customStyles?: React.CSSProperties }>`
  all: unset;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition:
    background 0.2s ease-in-out,
    transform 0.15s ease-in-out;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
    transform: scale(1.05);
  }

  &:active {
    background: rgba(0, 0, 0, 0.12);
    transform: scale(0.95);
  }

  ${({ $customStyles }) => applyCustomStyles($customStyles)}
`;

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  style,
  onClick,
  ariaLabel,
}: IconButtonProps) => {
  const theme = useTheme();
  const resolvedStyle =
    typeof style === 'function' ? style(theme) : (style ?? {});

  return (
    <StyledIconButton
      onClick={onClick}
      $customStyles={resolvedStyle}
      aria-label={ariaLabel}
    >
      {icon}
    </StyledIconButton>
  );
};
